/**
 * EventRowActions — the kebab on an event row in the report tables: View Details, and
 * Edit Reason when the campus allows it. The menu is position: fixed (so the table's
 * overflow cannot clip it), opens upward near the bottom of the window, and closes on an
 * outside click or any scroll.
 *
 * Replaces the identical copies in AlertDetailsTable and ExcessAlarmsTable
 * (docs/DUPLICATION_AUDIT.md, B17). The generic kebab shell is B23.
 *
 * @param {object} row — needs event_id
 * @param {(row) => void} onEditReason
 * @param {boolean} isReasonEditable
 */

import { Link } from 'react-router-dom';
import RowActionsMenu from './RowActionsMenu.jsx';

const EventRowActions = ({ row, onEditReason, isReasonEditable }) => {
    return (
        <RowActionsMenu label="Actions" classPrefix="ap">
            {(close) => (
                <>
                    <Link
                        to={`/profiles/event/${row.event_id}`}
                        className="ap-row-actions__item"
                        style={{ textDecoration: 'none' }}
                        onClick={() => close()}
                    >
                        <svg className="ap-icon-md ap-row-actions__item-icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        View Details
                    </Link>
                    {isReasonEditable ? (
                        <button
                            type="button"
                            className="ap-row-actions__item"
                            onClick={(e) => { e.stopPropagation(); close(); onEditReason(row); }}
                        >
                            <svg className="ap-icon-md ap-row-actions__item-icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                            </svg>
                            Edit Reason
                        </button>
                    ) : null}
                </>
            )}
        </RowActionsMenu>
    );
};

export default EventRowActions;
